import React, { Component } from "react";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { setObj } from "../../../../actions/noteActions";
import ActivityListPublic from "../../../../components/ActivityListPublic";
import Breadcrumb from "../../../../components/Breadcrumb";
import ProtectedRoute from "../../../../components/ProtectedRoute";

class ActivityBank extends Component {
  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
  }

  render() {
    return (
      <>
        <Breadcrumb current={this.props.currentRoute} />
        <ActivityListPublic {...this.props} />
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

ActivityBank.propTypes = {
  hideLayout: PropTypes.bool,
  guestLogin: PropTypes.bool
};

ActivityBank.defaultProps = {
  hideLayout: false,
  guestLogin: false
};

const mapStateToProps = state => ({});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setObj }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityBank);
